import React, { useEffect, ChangeEvent, useRef, Ref } from 'react';
import { MAX_CHARACTER_LIMIT_MESSAGE } from 'utils/constants';
import { StyledTextArea } from './style';

type ITextareaAutosizeProps = {
  limit: number;
  value?: string;
  error: boolean;
  height: number;
  handleChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
};
export const TextareaAutosize = (props: ITextareaAutosizeProps) => {
  const { value = '', handleChange, limit, error, height } = props;
  const textareaRef = useRef<any>(null);

  useEffect(() => {
    if (textareaRef) {
      // Default is the 6 rows or 6 * 16 = 192 px
      textareaRef.current.style.height = `${height}px`;
      // Only set for Initial Load of the text area
      if (!textareaRef.current.value) textareaRef.current.value = value;
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = `${scrollHeight}px`;
    }
  }, [value, height]);

  return (
    <StyledTextArea
      ref={textareaRef}
      limit={limit}
      value={value}
      error={error ? MAX_CHARACTER_LIMIT_MESSAGE : ''}
      onChange={handleChange}
    />
  );
};

export default TextareaAutosize;
